import type { LandingPageContent } from '../types'

export const ENCARGOS_FOTOVOLTAICA_INSTALADORES: LandingPageContent = {
  slug: 'encargos-fotovoltaica-instaladores',
  lang: 'es',
  topicId: 'handwerker-photovoltaik-auftraege',
  title: 'Encuentre encargos de fotovoltaica - gratis, sin suscripción | Para instaladores',
  metaDescription:
    'Vea solicitudes fotovoltaicas y presente presupuestos gratis, sin suscripción ni compra ' +
    'mínima - el contacto con el cliente solo tras su autorización activa.',
  keywords: [
    'encontrar encargos fotovoltaica',
    'comprar leads fotovoltaica',
    'leads fotovoltaica gratis',
    'portal instaladores fotovoltaica sin suscripción',
    'solicitudes fotovoltaica empresa instaladora',
  ],
  eyebrow: 'Para empresas instaladoras',
  h1: 'Encuentre encargos de fotovoltaica - gratis, sin suscripción',
  intro:
    'Roofora es completamente gratuito para empresas instaladoras: ver solicitudes, presentar ' +
    'presupuestos, entrar en contacto con clientes - sin suscripción, sin compra mínima, sin costes ' +
    'previos. Vea solicitudes fotovoltaicas anónimas de su región y decida usted mismo para cuáles ' +
    'presenta un presupuesto.',
  sections: [
    { type: 'heading', text: 'En qué se diferencia de los portales de leads tradicionales' },
    {
      type: 'paragraph',
      text:
        'Muchos portales venden a las empresas instaladoras los datos de contacto de interesados - a ' +
        'menudo por un precio fijo por lead, a veces con suscripción o compra mínima, ' +
        'independientemente de si de ahí surge un encargo. En Roofora, en cambio, ve solicitudes ' +
        'anónimas, presenta un presupuesto sin compromiso con precio fijo, y recibe los datos de ' +
        'contacto solo cuando el cliente autoriza individualmente a su empresa concreta - sin cesión ' +
        'general a varias empresas a la vez.',
    },
    { type: 'heading', text: 'Cómo funciona para su empresa' },
    {
      type: 'list',
      items: [
        'Regístrese gratis, sin permanencia',
        'Revise solicitudes anónimas de su región (código postal, datos del tejado, consumo)',
        'Presente un presupuesto con precio fijo sin compromiso, modificable en cualquier momento',
        'Reciba los datos de contacto del cliente solo tras su autorización individual para su empresa',
      ],
    },
    { type: 'heading', text: 'Sin necesidad de captación en frío' },
    {
      type: 'paragraph',
      text:
        'No necesita llamar a nadie para conseguir una solicitud - todas las solicitudes ya están ' +
        'ahí, anonimizadas y listas para su presupuesto. El esfuerzo de análisis de necesidades y ' +
        'primer contacto, que en otros sitios suele repercutir en el precio del presupuesto, ' +
        'desaparece en gran medida aquí.',
    },
  ],
  faq: [
    {
      q: '¿El registro o la presentación de presupuestos tiene algún coste?',
      a: 'No - el uso de Roofora es actualmente completamente gratuito para empresas instaladoras, sin suscripción ni compra mínima.',
    },
    {
      q: '¿Recibo automáticamente los datos de contacto del cliente al presentar un presupuesto?',
      a: 'No - el contacto solo se produce cuando el cliente autoriza individualmente a su empresa. Otras empresas pueden presentar presupuestos independientemente, sin que todas reciban automáticamente los datos de contacto.',
    },
    {
      q: '¿Cuántas otras empresas ven la misma solicitud?',
      a: 'Ve el número de presupuestos ya presentados, pero no sus precios - puede modificar su propio presupuesto en cualquier momento.',
    },
    {
      q: '¿Para qué tipos de encargo puedo registrarme?',
      a: 'Sistemas completos con instalación, solo montaje en tejado, instalación eléctrica y bomba de calor - según los servicios que ofrezca su empresa.',
    },
  ],
  primaryCta: { label: 'Registrarse gratis como empresa instaladora', action: 'craftsman' },
  secondaryCta: { label: '¿Cómo funciona la comparación de presupuestos para clientes?', action: 'link', href: '/comparar-presupuestos-fotovoltaicos' },
  relatedLinks: [
    { label: 'Cómo funciona la comparación de presupuestos', href: '/comparar-presupuestos-fotovoltaicos' },
    { label: 'Encontrar instalador fotovoltaico', href: '/encontrar-instalador-fotovoltaico' },
  ],
}
